import { useState } from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import './CollapsibleQRSection.css'

interface CollapsibleQRSectionProps {
  question: string
  answer: string
  index: number
  defaultExpanded?: boolean
}

const CollapsibleQRSection: React.FC<CollapsibleQRSectionProps> = ({
  question,
  answer,
  index,
  defaultExpanded = true
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded)

  return (
    <div
      id={`quick-response-${index}`}
      className={`quick-response-item ${isExpanded ? 'expanded' : 'collapsed'}`}
    >
      <div
        className="response-header-collapsible"
        onClick={() => setIsExpanded(!isExpanded)}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            setIsExpanded(!isExpanded)
          }
        }}
        aria-expanded={isExpanded}
      >
        <span className="collapse-icon">
          {isExpanded ? '▼' : '▶'}
        </span>
        <strong>Q:</strong> {question}
      </div>

      {isExpanded && (
        <div className="response-body">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>
            {answer}
          </ReactMarkdown>
        </div>
      )}
    </div>
  )
}

export default CollapsibleQRSection
